import { slideInBannerReducer } from 'app/marketplace/SlideInBanners/shared/redux/reducer';

export const sessionStorageReducers = {
  showSlideIn: slideInBannerReducer,
};
